export const CmsVI = {
    "category": "Danh mục",
    "tag": "Tag",
    "article": "Bài viết",
    "cmsSetting":"CMS"
}